import React, {  } from "react";

function SelectResponses(props) {
  const { selectName, selectId, optionId, formik } = props;
  let options = (
    <React.Fragment>
      <option value="0%">0%</option>
      <option value="<5%">&lt;5%</option>
      <option value="5-24%">5-24%</option>
      <option value="25-49%">24-49%</option>
      <option value="50-74%">50-74%</option>
      <option value="75-94%">75-94%</option>
      <option value=">95%">&gt;95%</option>
    </React.Fragment>
  );
  if (
    selectId === "flowerBudsIntensity" ||
    selectId === "fruitIntensity" ||
    selectId === "fruitDropIntensity" ||
    selectId === "breakingLeafBudsIntensity"
  ) {
    options = (
      <React.Fragment>
        <option value="0">0</option>
        <option value="<3">&lt;3</option>
        <option value="3-10">3-10</option>
        <option value="11-100">11-100</option>
        <option value="101-1,000">101-1,000</option>
        <option value="1,001-10,000">1,001-10,000</option>
        <option value=">10,000">&gt;10,000</option>
      </React.Fragment>
    );
  }
  if (selectId === "flowerPollenReleaseIntensity") {
    options = (
      <React.Fragment>
        <option value="None">None</option>
        <option value="Little">Little</option>
        <option value="Some">Some</option>
        <option value="Lots">Lots</option>
      </React.Fragment>
    );
  }

  return (
    <div class="selectResponses">
      <select name={selectName} id={selectId} onChange={formik.handleChange}>
        <option id={optionId} value={null}>
          Select an option
        </option>
        {options}
      </select>
    </div>
  );
}

export default SelectResponses;
